export const CAMPAIGN_ELIGIBLE_FORM_TYPES = ['CAPTURED', 'HUBSPOT', 'BLOG_COMMENT'];
export function isCampaignEligibleFormType(formType) {
  if (!formType) {
    return false;
  }
  return CAMPAIGN_ELIGIBLE_FORM_TYPES.includes(formType);
}